
        var result = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./Nav.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./packages/nav/Nav.scss
// module id = 20
// module chunks = 1 2